<template>
  <b-row align-h="center">
    <b-col
      sm="9"
      md="6"
      xl="5"
      class="d-flex flex-column justify-content-center"
    >
      <Card>
        <template #body>
          <div class="login-page">
            <!--begin::Signin-->
            <div class="login-form login-signin">
              <div class="text-center mb-8">
                <h1 class="font-size-h1 mb-6">Log In</h1>
                <p class="text-muted font-weight-semi-bold mb-4">
                  Enter your e-mail adres and password.
                </p>
                <p v-if="fromCece" class="text-muted mb-4">
                  (You can use the same credentials as for your Project Cece
                  account)
                </p>
              </div>

              <!--begin::Form-->
              <Form
                :fields="fields"
                size="lg"
                :submitLabel="$t('LOG_IN.FORM.BUTTON')"
                :isLoading="isLoading"
                :generalError="
                  errors && errors.length > 0
                    ? errors[0]
                    : $t('LOG_IN.FORM.GENERAL_ERROR')
                "
                :showGeneralError="
                  (errors && errors.length > 0) || showGeneralError
                "
                @submit="onSubmit"
              >
                <template #submitRow="{ isLoading, submitLabel }">
                  <b-row>
                    <b-col class="d-flex justify-content-between">
                      <router-link
                        class="text-dark-60 text-hover-primary my-3 mr-2"
                        id="kt_login_forgot"
                        to="/password-reset/"
                      >
                        Forgot Password?
                      </router-link>
                      <Button :isLoading="isLoading">
                        {{ submitLabel }}
                      </Button>
                    </b-col>
                  </b-row>
                </template>
              </Form>
              <p class="mt-12 text-center">
                Don't have an account yet?
                <router-link to="/signup/">Sign up</router-link> here.
              </p>
            </div>
          </div>
        </template>
      </Card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import { CLEAR_ERRORS, LOGIN } from "@/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

import Card from "@/components/Card.vue";
import Form from "@/components/form/Form.vue";
import Button from "@/components/buttons/Button.vue";

export default {
  mixins: [validationMixin],
  name: "login",
  components: {
    Card,
    Form,
    Button
  },
  data() {
    return {
      redirectTo: null,
      isLoading: false,
      showGeneralError: false,
      fromCece: false,
      fields: {
        email: {
          type: "email",
          validations: { required, email },
          placeholder: "example@example.com",
          errors: {
            required: this.$t("LOG_IN.FORM.EMAIL.REQUIRED"),
            email: this.$t("LOG_IN.FORM.EMAIL.VALID")
          }
        },
        password: {
          type: "password",
          validations: { required },
          placeholder: this.$t("LOG_IN.FORM.PASSWORD.PLACEHOLDER"),
          errors: {
            required: this.$t("LOG_IN.FORM.PASSWORD.REQUIRED")
          }
        }
      }
    };
  },
  created() {
    this.fromCece = this.$route.query["from-cece"] === "true";
  },
  beforeMount() {
    if (this.$route.query.redirect) {
      this.redirectTo = this.$route.query.redirect;
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    isImpactBytes() {
      return process.env.VUE_APP_ID === "impactbytes";
    }
  },
  methods: {
    async onSubmit(form) {
      // Show spinner on submit button
      this.isLoading = true;

      const { email, password } = form;

      // Clear existing errors
      this.$store.commit(CLEAR_ERRORS);
      this.showGeneralError = false;

      try {
        // Send login request
        await this.$store.dispatch(LOGIN, { email, password });

        const dashboardRoutes = [
          "/dashboard",
          "/dashboard/",
          "/w/dashboard",
          "/w/dashboard/",
          "/p/dashboard",
          "/p/dashboard/"
        ];
        if (this.redirectTo && !dashboardRoutes.includes(this.redirectTo)) {
          this.$router.push(this.redirectTo);
        } else if (this.$store.getters.isPublisherUser) {
          this.$router.push("/p/dashboard/");
        } else {
          this.$router.push("/w/dashboard/");
        }
      } catch (err) {
        console.error("Error logging in", err);
        this.showGeneralError = true;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
